const TimeInput = ({selectedTime, handleSelectedTime, disabled = false}) => {
    return (
      <input
          disabled={disabled}
          type="time"
          id="time"
          step="1"
          className="choice-input"
          value={selectedTime}
          onChange={handleSelectedTime}  
      />
    );
  };
  
  export default TimeInput;
  